import React, { useEffect, useRef, useState } from "react";
import { STATS } from "../../mock/mock";
import { useCountUp } from "../../hooks/useReveal";

function Stat({ item, active }) {
  const value = useCountUp(item.value, active);
  return (
    <div className="text-center">
      <p className="font-heading font-extrabold text-4xl md:text-5xl text-white">
        {value.toLocaleString()}<span className="text-homi-gold">{item.suffix}</span>
      </p>
      <p className="text-white/60 mt-2 font-medium">{item.label}</p>
    </div>
  );
}

export default function Stats() {
  const ref = useRef(null);
  const [active, setActive] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(([e]) => e.isIntersecting && (setActive(true), obs.disconnect()), { threshold: 0.3 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={ref} className="relative py-16 bg-homi-black overflow-hidden">
      <div className="absolute inset-0 opacity-15" style={{ backgroundImage: "radial-gradient(circle at 20% 50%, #c8912f 0, transparent 42%), radial-gradient(circle at 80% 50%, #c8912f 0, transparent 42%)" }} />
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-2 lg:grid-cols-3 gap-10 relative">
        {STATS.map((s) => <Stat key={s.label} item={s} active={active} />)}
      </div>
    </section>
  );
}
